import { playerListIdentitiesMap, playerTagIdentityMap } from "./Map"

const PlayerListFrame = ({title, players, handleOnClick}) => {
  const showSingleName = (p) => {
    return <div className="person_name_block" onClick={()=>{handleOnClick(p)}}>{p.name}</div>
  }
  return (
    <div className="player_list">
      <div className='page_tab_frame2'>
        <div className='tab_block tab_selected'>
          <div className='tab'>{title}</div>
        </div>
      </div>
      <div className='tab_content'>
        <div className='person_name_frame'>
          {players.map((e)=>(showSingleName(e)))}
        </div>
      </div>
    </div>
  )
}

const classifyPlayers = (type, all, valid) => {
  let classified = type==='pitcher'? {'LHP': [], 'RHP': []}:{'IF': [], 'OF': [], 'C': []}
  if (all.ids[0] === undefined) return classified
  let idx = 0;
  for (const p of all.names) {
    let id = all.ids[idx]
    let tag = all.idMap[id].tag
    idx++;
    if (valid.includes(p)) classified[playerTagIdentityMap[tag]].push({name: p, id})
  }
  return classified
}

export const PlayerList = ({type, allPlayers, validPlayers, handleOnClick}) => {
  let classes = classifyPlayers(type, allPlayers, validPlayers)
  return (
    <>
      { playerListIdentitiesMap[type].map((e)=>(<PlayerListFrame title={e} players={classes[e]} handleOnClick={handleOnClick} />)) }
    </>
  )
}